<template lang="html">
  <!-- <div class="el-notification" v-show="notice.alertWarn" style="top: 16px; z-index: 2000;">
    <i class="el-notification__icon el-icon-warning"></i>
    <div class="el-notification__group is-with-icon">
      <h2 class="el-notification__title" @click="startApp()">点击启动Transceiver</h2>
      <div class="el-notification__content">
        Transceiver 未启动<br/>
        <a  class="download" :href="downloadUrl"  target="blank" @click="toDwonload">软件下载</a>
      </div>
      <div class="el-notification__closeBtn el-icon-close" @click="closeWarn()"></div>
    </div>
  </div> -->
  <div></div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      time: 1200,
      keepFunc: null,
      downloadUrl: ''
    }
  },
  computed: {
    ...mapGetters({
      app: 'app',
      clearKeep: 'clearKeep',
      notice: 'notice'
    })
  },
  watch: {
    'clearKeep': function (val) {
      if (val) {
        this.clearKeepFunc()
      }
    },
    'app.login': function (val) {
      if (val) {
        if (!this.keepFunc) {
          this.keepAppAlive()
        }
      } else {
        if (this._global.config.browser !== 'qt') {
          this.clearKeepFunc()
        }
      }
    },
    'app.type': function (val) {
      if (val) {
        this.$store.dispatch('alertWarn', false)
        this.$store.dispatch('showDown', false)
      } else {
        if (localStorage.getItem('token') !== '') {
          // this.$store.dispatch('alertWarn', true)
        }
      }
    }
  },
  mounted () {
    if (this.app.type) {
      this.$store.dispatch('alertWarn', false)
    } else {
      if (localStorage.getItem('token') !== '') {
        // this.$store.dispatch('alertWarn', true)
      }
    }
    if (localStorage.getItem('completeNum')) {
      this.$store.dispatch('donePkg', parseInt(localStorage.getItem('completeNum')))
    }
    this.keepApp()
    this.keepAppAlive()
  },
  methods: {
    startApp () {
      this.closeWarn()
      this.$app.start()
    },
    closeWarn () {
      this.$store.dispatch('alertWarn', false)
    },
    toDwonload () {
    },
    keepApp () {
      if (localStorage.getItem('token')) {
        this.$app.queryTask(response => {
          if (response.error === 0 || response.error === 100) {
            var x = this.notice.newPkg
            var y = this.notice.donePkg
            for (var i = 0; i < response.pkgEvents.length; i++) {
              if (response.pkgEvents[i].error >= 1000) {
                var errorNumA = 'l' + (response.pkgEvents[i].error - 1000)
                this.$message.error(this.$lang.systemError[errorNumA])
              }
              if (response.pkgEvents[i].event === 512) {
                x.push(response.pkgEvents[i].projectId)
              }
            }
            for (var a = 0; a < response.taskEvents.length; a++) {
              if (response.taskEvents[a].error >= 1000) {
                if (response.taskEvents[a].error === 1106) {
                  if (response.taskEvents[a].event === 263) {
                    var err = this.$lang.ui.prompt.l150.l0 + localStorage.getItem('projectName') + this.$lang.ui.prompt.l150.l2
                  }
                  if (response.taskEvents[a].event === 7) {
                    err = this.$lang.ui.prompt.l150.l0 + localStorage.getItem('projectName') + this.$lang.ui.prompt.l150.l1
                  }
                  this.$message.error(err)
                } else {
                  var errorNum = 'l' + (response.taskEvents[a].error - 1000)
                  this.$message.error(this.$lang.systemError[errorNum])
                }
              }
              if (
                response.taskEvents[a].event === 9 ||
                response.taskEvents[a].event === 265
              ) {
                y = y + 1
              }
            }
            if (x.length !== 0) {
              this.$store.dispatch('newPkg', x)
            }
            if (y !== 0) {
              this.$store.dispatch('donePkg', y)
              localStorage.setItem('completeNum', y)
            }
          }
          this.$store.dispatch('addAlive', response)
        })
      } else {
        this.clearKeepFunc()
      }
    },
    keepAppAlive () {
      if (this.app.type && this.app.login) {
        this.clearKeepFunc()
        var that = this
        this.$store.dispatch('clearKeep', false)
        this.keepFunc = setInterval(() => {
          this.keepApp()
        }, that.time)
      } else {
        this.clearKeepFunc()
      }
    },
    clearKeepFunc () {
      clearInterval(this.keepFunc)
      this.keepFunc = null
    },
  },
  beforeDestroy () {
    this.clearKeepFunc()
  },
}
</script>

<style scoped lang="css">
.el-notification {
  top: 80px !important;
}
.el-notification__title {
  text-align: left;
  cursor: pointer;
  color: #0291cf;
}
.el-notification__title:hover {
  color: #20a0ff;
}
.download {
  display: block;
  height: 22px;
  text-align: right;
  line-height: 40px;
  color: rgba(2, 145, 207, 0.87);
}
</style>
